import { Layout } from "../../containers";
import React, { useEffect, useState } from "react";
import { Grilla } from "../../componentes";
import { Redirect } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import firebase from "../../../lib/fire";
import { UpgradeContainer } from "../../../components";

export default function Main() {
  const [userInfo, setUserInfo] = useState(null);
  const userAuth = secureLocalStorage.getItem("user");
  const userLocalId = secureLocalStorage.getItem("userId");
  const sessionUser = sessionStorage.getItem("user");

  useEffect(() => {
    if (userLocalId !== null && userLocalId !== "") {
      try {
        const data = firebase
          .database()
          .ref(`/users/0/${userLocalId}`)
          .once("value")
          .then((snapshot) => {
            var username = snapshot.val() || "Anonymous";
            secureLocalStorage.setItem("userLocal", username);
            setUserInfo(username);
          });
      } catch (error) {
        console.error("este es mi error", error);
      }
    }
  }, [userLocalId]);

  return (
    <Layout>
      {sessionUser !== null ? <Grilla user={userInfo} /> : <UpgradeContainer />}
    </Layout>
  );
}
